export default class ListCommitterCtrl{

  constructor($rootScope,$scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $state, $cookies){
    const listCommVM = this
    listCommVM.listCommiters=[]
    listCommVM.usuario = JSON.parse($cookies.get('currentUser'))
    $rootScope.fullscreenClass = 'background-planning'
    listCommVM.filter = filter
    listCommVM.singleFilter = singleFilter
    listCommVM.isActive = isActive
    listCommVM.selectCommittee = selectCommittee
    listCommVM.selectedCommittee = 0
    listCommVM.noData=false

    // Grid definition
    
    listCommVM.gridOptions = {
      enableFiltering: true,
      columnDefs: [
        {
          displayName: 'Nombre Profesor',
          name: 'Nombre Profesor',
          field: 'teacherName',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Plan de Trabajo asignado',
          name: 'Plan de Trabajo asignado',
          field: 'workplanName',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Estado',
          name: 'Estado',
          field: 'stageName',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: true,
        }, {
          displayName: 'Acciones',
          name: 'Acciones',
          field: 'stageId',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: require('./cellTemplateWorkPlanActions.html')
        }
      ],
      onRegisterApi: (gridApi) => {
        listCommVM.gridApi = gridApi
        listCommVM.gridApi.grid.registerRowsProcessor( listCommVM.singleFilter, 200 );
        $interval(function () {
          listCommVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }

    function filter () {
      listCommVM.gridApi.grid.refresh()
    }

    function singleFilter(renderableRows){
      var matcher = new RegExp(listCommVM.committeerFilter, 'i');
      renderableRows.forEach( function( row ) {
        var match = false;
        [ 'teacherName', 'workplanName' ].forEach(function( field ){
          if ( row.entity[field] && row.entity[field].match(matcher) ){
            match = true;
          }
        });
        if ( !match ){
          row.visible = false;
        }
      });
      return renderableRows;
    };

    activate()
    
    function activate(){
        let requestHeader = {
            idUser: listCommVM.usuario.id
        }    
        GeneralSettingsSrv.getCommitteersByUser.get(requestHeader).$promise.then((dataReturn) =>{
            if(dataReturn.status == true){
                listCommVM.listCommiters=dataReturn.data
                listCommVM.gridOptions.data = listCommVM.listCommiters[0].teacher
                if(!listCommVM.gridOptions.data.length)
                    listCommVM.noData=true
                else
                    listCommVM.noData=false
            }
        })
    } 
    function selectCommittee(index){
        listCommVM.selectedCommittee = index
        listCommVM.gridOptions.data = listCommVM.listCommiters[index].teacher
        if(!listCommVM.gridOptions.data.length)
            listCommVM.noData=true
        else
            listCommVM.noData=false
    }

    function isActive(index){
        if(listCommVM.selectedCommittee == index)
            return "active"
    }
  }
}
ListCommitterCtrl.$inject = ['$rootScope','$scope','GeneralSettingsSrv','$mdDialog','$interval','uiGridConstants','i18nService', '$state', '$cookies'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/userCommittee/listCommitteCtrl.js